import React from "react";
import PropTypes from "prop-types";
import { useMutation } from "react-query";
import RideService from "../../../../services/ride";
import CancelModal from "../../CancelModal";

const CancelRide = React.memo(({ onCardRemoved, setCardRemoving, rideId, ...props }) => {
  const [ baseRate, setBaseRate ] = React.useState(undefined);
  const [ cancelModal, setCancelModal ] = React.useState(false);
  const [ reasonModal, setReasonModal ] = React.useState(false);
  const [ selectedReason, setSelectedReason ] = React.useState(undefined);
  const [ commentReason, setCommentReason ] = React.useState("");
  const [ mutate, { isLoading } ] = useMutation(() =>
      RideService.cancel(rideId,
        { cancelReason: selectedReason },
        { cancelComment: commentReason }),
    { onSettled: onCardRemoved }); // TO DO process error

  const getBaseRate = () =>
    RideService.cancellation(rideId)
      .then(({ baseRate }) => {
        if (!baseRate) {
          setCancelModal(true);
          setReasonModal(true);
        } else {
          setBaseRate(baseRate);
          setCancelModal(true);
        }
      });

  const closeModal = () => {
    setReasonModal(false);
    setCancelModal(false);
    setCardRemoving(false);
  };
  const getCancelRide = () => {
    closeModal();
    mutate();
  };
  return (
    <>
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setCardRemoving(true);
          getBaseRate();
        }}
        type="button"
        {...props}
        disabled={isLoading || props.disabled}
      >
        Cancel ride
      </button>
      {cancelModal &&
      <CancelModal
        baseRate={baseRate}
        open={cancelModal}
        closeModal={closeModal}
        openReasonModal={setReasonModal}
        reasonModal={reasonModal}
        selectedReason={selectedReason}
        setSelectedReason={setSelectedReason}
        commentReason={commentReason}
        setCommentReason={setCommentReason}
        handleCancelRide={getCancelRide}
      />}
    </>
  );
});

CancelRide.propTypes = {
  setCardRemoving: PropTypes.func,
  onCardRemoved: PropTypes.func,
  rideId: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
};
CancelRide.defaultProps = {
  setCardRemoving: undefined,
  onCardRemoved: undefined,
  rideId: undefined,
};

export default CancelRide;
